/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CommonDetails } from '../models/common-details';
import { DeviceCountDto } from '../models/device-count-dto';
import { FotaBasicDto } from '../models/fota-basic-dto';
import { FotaBasicResponseDto } from '../models/fota-basic-response-dto';
import { FotaDeviceDetailsResponseDto } from '../models/fota-device-details-response-dto';
import { FotaJobBasicDto } from '../models/fota-job-basic-dto';
import { FotaJobMasterDto } from '../models/fota-job-master-dto';
import { FotaSearchDto } from '../models/fota-search-dto';
import { Resource } from '../models/resource';

@Injectable({
  providedIn: 'root',
})
export class FotaJobControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getFotaJobsBySearchCriteria
   */
  static readonly GetFotaJobsBySearchCriteriaPath = '/api/v1/fotajobs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFotaJobsBySearchCriteria()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getFotaJobsBySearchCriteria$Response(params?: {
    page?: number;
    limit?: number;
    totalcount?: number;
    body?: FotaSearchDto
  }): Observable<StrictHttpResponse<FotaBasicResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetFotaJobsBySearchCriteriaPath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('totalcount', params.totalcount, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FotaBasicResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFotaJobsBySearchCriteria$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getFotaJobsBySearchCriteria(params?: {
    page?: number;
    limit?: number;
    totalcount?: number;
    body?: FotaSearchDto
  }): Observable<FotaBasicResponseDto> {

    return this.getFotaJobsBySearchCriteria$Response(params).pipe(
      map((r: StrictHttpResponse<FotaBasicResponseDto>) => r.body as FotaBasicResponseDto)
    );
  }

  /**
   * Path part for operation getFotaFirmwares
   */
  static readonly GetFotaFirmwaresPath = '/api/v1/solutiontype/{solutiontypeId}/devicetype/{devicetypeId}/fotajob/firmware';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFotaFirmwares()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaFirmwares$Response(params: {
    solutiontypeId: string;
    devicetypeId: string;
  }): Observable<StrictHttpResponse<Array<CommonDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetFotaFirmwaresPath, 'get');
    if (params) {
      rb.path('solutiontypeId', params.solutiontypeId, {});
      rb.path('devicetypeId', params.devicetypeId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommonDetails>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFotaFirmwares$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaFirmwares(params: {
    solutiontypeId: string;
    devicetypeId: string;
  }): Observable<Array<CommonDetails>> {

    return this.getFotaFirmwares$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommonDetails>>) => r.body as Array<CommonDetails>)
    );
  }

  /**
   * Path part for operation getFotaCreatorsList
   */
  static readonly GetFotaCreatorsListPath = '/api/v1/solutiontype/{solutiontypeId}/fotajob/createdBy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFotaCreatorsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaCreatorsList$Response(params: {
    solutiontypeId: string;
  }): Observable<StrictHttpResponse<Array<CommonDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetFotaCreatorsListPath, 'get');
    if (params) {
      rb.path('solutiontypeId', params.solutiontypeId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommonDetails>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFotaCreatorsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaCreatorsList(params: {
    solutiontypeId: string;
  }): Observable<Array<CommonDetails>> {

    return this.getFotaCreatorsList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommonDetails>>) => r.body as Array<CommonDetails>)
    );
  }

  /**
   * Path part for operation saveFotaJob
   */
  static readonly SaveFotaJobPath = '/api/v1/fotajob';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveFotaJob()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveFotaJob$Response(params?: {
    body?: FotaJobMasterDto
  }): Observable<StrictHttpResponse<FotaJobMasterDto>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.SaveFotaJobPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FotaJobMasterDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `saveFotaJob$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveFotaJob(params?: {
    body?: FotaJobMasterDto
  }): Observable<FotaJobMasterDto> {

    return this.saveFotaJob$Response(params).pipe(
      map((r: StrictHttpResponse<FotaJobMasterDto>) => r.body as FotaJobMasterDto)
    );
  }

  /**
   * Path part for operation getFotaJobById
   */
  static readonly GetFotaJobByIdPath = '/api/v1/fotajob/{fotaJobId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFotaJobById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaJobById$Response(params: {
    fotaJobId: string;
  }): Observable<StrictHttpResponse<FotaJobMasterDto>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetFotaJobByIdPath, 'get');
    if (params) {
      rb.path('fotaJobId', params.fotaJobId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FotaJobMasterDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFotaJobById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaJobById(params: {
    fotaJobId: string;
  }): Observable<FotaJobMasterDto> {

    return this.getFotaJobById$Response(params).pipe(
      map((r: StrictHttpResponse<FotaJobMasterDto>) => r.body as FotaJobMasterDto)
    );
  }

  /**
   * Path part for operation deleteFotaJob
   */
  static readonly DeleteFotaJobPath = '/api/v1/fotajob/{fotaJobId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFotaJob()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFotaJob$Response(params: {
    fotaJobId: string;
  }): Observable<StrictHttpResponse<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.DeleteFotaJobPath, 'delete');
    if (params) {
      rb.path('fotaJobId', params.fotaJobId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteFotaJob$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFotaJob(params: {
    fotaJobId: string;
  }): Observable<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'> {

    return this.deleteFotaJob$Response(params).pipe(
      map((r: StrictHttpResponse<'100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED'>) => r.body as '100 CONTINUE' | '101 SWITCHING_PROTOCOLS' | '102 PROCESSING' | '103 CHECKPOINT' | '200 OK' | '201 CREATED' | '202 ACCEPTED' | '203 NON_AUTHORITATIVE_INFORMATION' | '204 NO_CONTENT' | '205 RESET_CONTENT' | '206 PARTIAL_CONTENT' | '207 MULTI_STATUS' | '208 ALREADY_REPORTED' | '226 IM_USED' | '300 MULTIPLE_CHOICES' | '301 MOVED_PERMANENTLY' | '302 FOUND' | '302 MOVED_TEMPORARILY' | '303 SEE_OTHER' | '304 NOT_MODIFIED' | '305 USE_PROXY' | '307 TEMPORARY_REDIRECT' | '308 PERMANENT_REDIRECT' | '400 BAD_REQUEST' | '401 UNAUTHORIZED' | '402 PAYMENT_REQUIRED' | '403 FORBIDDEN' | '404 NOT_FOUND' | '405 METHOD_NOT_ALLOWED' | '406 NOT_ACCEPTABLE' | '407 PROXY_AUTHENTICATION_REQUIRED' | '408 REQUEST_TIMEOUT' | '409 CONFLICT' | '410 GONE' | '411 LENGTH_REQUIRED' | '412 PRECONDITION_FAILED' | '413 PAYLOAD_TOO_LARGE' | '413 REQUEST_ENTITY_TOO_LARGE' | '414 URI_TOO_LONG' | '414 REQUEST_URI_TOO_LONG' | '415 UNSUPPORTED_MEDIA_TYPE' | '416 REQUESTED_RANGE_NOT_SATISFIABLE' | '417 EXPECTATION_FAILED' | '418 I_AM_A_TEAPOT' | '419 INSUFFICIENT_SPACE_ON_RESOURCE' | '420 METHOD_FAILURE' | '421 DESTINATION_LOCKED' | '422 UNPROCESSABLE_ENTITY' | '423 LOCKED' | '424 FAILED_DEPENDENCY' | '425 TOO_EARLY' | '426 UPGRADE_REQUIRED' | '428 PRECONDITION_REQUIRED' | '429 TOO_MANY_REQUESTS' | '431 REQUEST_HEADER_FIELDS_TOO_LARGE' | '451 UNAVAILABLE_FOR_LEGAL_REASONS' | '500 INTERNAL_SERVER_ERROR' | '501 NOT_IMPLEMENTED' | '502 BAD_GATEWAY' | '503 SERVICE_UNAVAILABLE' | '504 GATEWAY_TIMEOUT' | '505 HTTP_VERSION_NOT_SUPPORTED' | '506 VARIANT_ALSO_NEGOTIATES' | '507 INSUFFICIENT_STORAGE' | '508 LOOP_DETECTED' | '509 BANDWIDTH_LIMIT_EXCEEDED' | '510 NOT_EXTENDED' | '511 NETWORK_AUTHENTICATION_REQUIRED')
    );
  }

  /**
   * Path part for operation updateFotaJob
   */
  static readonly UpdateFotaJobPath = '/api/v1/fotajob/{fotaJobId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFotaJob()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFotaJob$Response(params: {
    fotaJobId: string;
    body?: FotaJobMasterDto
  }): Observable<StrictHttpResponse<FotaJobMasterDto>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.UpdateFotaJobPath, 'patch');
    if (params) {
      rb.path('fotaJobId', params.fotaJobId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FotaJobMasterDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateFotaJob$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFotaJob(params: {
    fotaJobId: string;
    body?: FotaJobMasterDto
  }): Observable<FotaJobMasterDto> {

    return this.updateFotaJob$Response(params).pipe(
      map((r: StrictHttpResponse<FotaJobMasterDto>) => r.body as FotaJobMasterDto)
    );
  }

  /**
   * Path part for operation fota
   */
  static readonly FotaPath = '/api/v1/solutionType/{solutionTypeId}/fotajobs/{jobId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fota()` instead.
   *
   * This method doesn't expect any request body.
   */
  fota$Response(params: {
    solutionTypeId: string;
    jobId: string;
    action: string;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.FotaPath, 'post');
    if (params) {
      rb.path('solutionTypeId', params.solutionTypeId, {});
      rb.path('jobId', params.jobId, {});
      rb.query('action', params.action, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `fota$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fota(params: {
    solutionTypeId: string;
    jobId: string;
    action: string;
  }): Observable<{
}> {

    return this.fota$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation getFotaJobEnum
   */
  static readonly GetFotaJobEnumPath = '/api/v1/fotajob/status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFotaJobEnum()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaJobEnum$Response(params?: {
  }): Observable<StrictHttpResponse<Array<CommonDetails>>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetFotaJobEnumPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommonDetails>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFotaJobEnum$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaJobEnum(params?: {
  }): Observable<Array<CommonDetails>> {

    return this.getFotaJobEnum$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommonDetails>>) => r.body as Array<CommonDetails>)
    );
  }

  /**
   * Path part for operation getFotaJobs
   */
  static readonly GetFotaJobsPath = '/api/v1/solutionType/{solutionTypeId}/fotajobs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFotaJobs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaJobs$Response(params: {
    page?: number;
    limit?: number;
    status?: string;
    solutionTypeId: string;
  }): Observable<StrictHttpResponse<FotaBasicResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetFotaJobsPath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('status', params.status, {});
      rb.path('solutionTypeId', params.solutionTypeId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FotaBasicResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFotaJobs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaJobs(params: {
    page?: number;
    limit?: number;
    status?: string;
    solutionTypeId: string;
  }): Observable<FotaBasicResponseDto> {

    return this.getFotaJobs$Response(params).pipe(
      map((r: StrictHttpResponse<FotaBasicResponseDto>) => r.body as FotaBasicResponseDto)
    );
  }

  /**
   * Path part for operation getFotaProgress
   */
  static readonly GetFotaProgressPath = '/api/v1/fotajob/{fotaId}/progress';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFotaProgress()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaProgress$Response(params: {
    fotaId: string;
  }): Observable<StrictHttpResponse<FotaBasicDto>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetFotaProgressPath, 'get');
    if (params) {
      rb.path('fotaId', params.fotaId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FotaBasicDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFotaProgress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaProgress(params: {
    fotaId: string;
  }): Observable<FotaBasicDto> {

    return this.getFotaProgress$Response(params).pipe(
      map((r: StrictHttpResponse<FotaBasicDto>) => r.body as FotaBasicDto)
    );
  }

  /**
   * Path part for operation getFotaDeviceCount
   */
  static readonly GetFotaDeviceCountPath = '/api/v1/solutiontype/{solutionTypeId}/fotajob/{fotajobId}/device/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFotaDeviceCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaDeviceCount$Response(params: {
    solutionTypeId: string;
    fotajobId: string;
  }): Observable<StrictHttpResponse<Array<DeviceCountDto>>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetFotaDeviceCountPath, 'get');
    if (params) {
      rb.path('solutionTypeId', params.solutionTypeId, {});
      rb.path('fotajobId', params.fotajobId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DeviceCountDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFotaDeviceCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaDeviceCount(params: {
    solutionTypeId: string;
    fotajobId: string;
  }): Observable<Array<DeviceCountDto>> {

    return this.getFotaDeviceCount$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DeviceCountDto>>) => r.body as Array<DeviceCountDto>)
    );
  }

  /**
   * Path part for operation getFotaDeviceDetails
   */
  static readonly GetFotaDeviceDetailsPath = '/api/v1/solutiontype/{solutionTypeId}/fotajob/{fotajobId}/device';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFotaDeviceDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaDeviceDetails$Response(params: {
    solutionTypeId: string;
    fotajobId: string;
    status?: string;
    deviceId?: string;
    page?: number;
    limit?: number;
  }): Observable<StrictHttpResponse<FotaDeviceDetailsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetFotaDeviceDetailsPath, 'get');
    if (params) {
      rb.path('solutionTypeId', params.solutionTypeId, {});
      rb.path('fotajobId', params.fotajobId, {});
      rb.query('status', params.status, {});
      rb.query('deviceId', params.deviceId, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FotaDeviceDetailsResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFotaDeviceDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaDeviceDetails(params: {
    solutionTypeId: string;
    fotajobId: string;
    status?: string;
    deviceId?: string;
    page?: number;
    limit?: number;
  }): Observable<FotaDeviceDetailsResponseDto> {

    return this.getFotaDeviceDetails$Response(params).pipe(
      map((r: StrictHttpResponse<FotaDeviceDetailsResponseDto>) => r.body as FotaDeviceDetailsResponseDto)
    );
  }

  /**
   * Path part for operation getdeviceErrorLog
   */
  static readonly GetdeviceErrorLogPath = '/api/v1/solutiontype/{solutionTypeId}/fotajob/{fotajobId}/device/{deviceId}/log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getdeviceErrorLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  getdeviceErrorLog$Response(params: {
    solutionTypeId: string;
    fotajobId: string;
    deviceId: string;
  }): Observable<StrictHttpResponse<Resource>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetdeviceErrorLogPath, 'get');
    if (params) {
      rb.path('solutionTypeId', params.solutionTypeId, {});
      rb.path('fotajobId', params.fotajobId, {});
      rb.path('deviceId', params.deviceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Resource>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getdeviceErrorLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getdeviceErrorLog(params: {
    solutionTypeId: string;
    fotajobId: string;
    deviceId: string;
  }): Observable<Resource> {

    return this.getdeviceErrorLog$Response(params).pipe(
      map((r: StrictHttpResponse<Resource>) => r.body as Resource)
    );
  }

  /**
   * Path part for operation getFotaJobBasicById
   */
  static readonly GetFotaJobBasicByIdPath = '/api/v1/fotajobbasic/{fotaJobId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFotaJobBasicById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaJobBasicById$Response(params: {
    fotaJobId: string;
  }): Observable<StrictHttpResponse<FotaJobBasicDto>> {

    const rb = new RequestBuilder(this.rootUrl, FotaJobControllerService.GetFotaJobBasicByIdPath, 'get');
    if (params) {
      rb.path('fotaJobId', params.fotaJobId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FotaJobBasicDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFotaJobBasicById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFotaJobBasicById(params: {
    fotaJobId: string;
  }): Observable<FotaJobBasicDto> {

    return this.getFotaJobBasicById$Response(params).pipe(
      map((r: StrictHttpResponse<FotaJobBasicDto>) => r.body as FotaJobBasicDto)
    );
  }

}
